import platforms from './reducers';

export default platforms;
